import { render, staticRenderFns } from "./Create-Payment-Credit-Note.vue?vue&type=template&id=08035247&scoped=true"
import script from "./Create-Payment-Credit-Note.vue?vue&type=script&lang=js"
export * from "./Create-Payment-Credit-Note.vue?vue&type=script&lang=js"
import style0 from "./Create-Payment-Credit-Note.vue?vue&type=style&index=0&id=08035247&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08035247",
  null
  
)

export default component.exports